export const REFRESH_ENDPOINT = '/api/account/auth/refresh';

export default REFRESH_ENDPOINT;
